// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b3756501","455":"64ea277d"}[chunkId] + ".chunk.js";
};